import { ITiledLayer, ITiledMap, ITiledTileLayer, ITiledImageLayer, ITiledProperty, ITiledLayerGroup } from "./Defs";
import { MapRow } from "../MapRow";
import { MapSection } from "../MapSection";
import { MapCell } from "../MapCell";
import { ObstacleMapData } from "../../Obstacles/ObstacleMapData";
import { ObstacleSettings } from "../../Obstacles/ObstacleSettings";
import { eObstacleType } from "../../Obstacles/ObstacleTypes";
import { MapRowShiftSettings } from "../MapRowSettings";
import { IDictionary } from "../../../../Utils/Collections/Dictionary";
import { ShiftingObsSettings } from "../../Obstacles/Shifting/ObstacleSettings";
import { TileBase } from "../../Ground Tiles/TileBase";
import { MovingObsSettings } from "../../Obstacles/Moving/MovingObsSettings";
import { MovingObsMapData } from "../../Obstacles/Moving/MovingObsMapData";
import { HammerObsMapData } from "../../Obstacles/Hammer/HammerObsMapData";
import { RotatorObsMapData } from "../../Obstacles/Rotator/RotatorObsMapData";
import { CannonObsSettings } from "../../Obstacles/Cannon/CannonObsSettings";



class Cell {
    /**
     * Data bunky, kde je zakodovana dlazdice, bonus, ...
     */
    cell: number;
    /**
     * Prekazka nebo undefined
     */
    obstacle: ObstacleMapData;
    /**
     * Posun radky
     */
    rowShift: MapRowShiftSettings;
}


type TiledPropertyVal = number | string | boolean;



class SectionTag {
    /**
     * UID sekce
     */
    uid: string;
    /**
     * Index radky v ramci cele mapy
     */
    row: number;

    constructor(uid: string, row: number) {
        this.uid = uid;
        this.row = row;
    }
}



/**
 * 
 */
export class Convertor {
    //#region Jmena vrstev
    private static readonly LAYER_GROUND_NAME = "Ground";
    private static readonly LAYER_OBJECTS_NAME = "Objects";
    private static readonly LAYER_SETTINGS_NAME = "Settings";
    private static readonly LAYER_SECTION_TAGS_NAME = "SectionTags";
    //#endregion

    //#region Index dlazdic

    private static readonly SECTION_START_TILE_ID = 8;
    private static readonly SECTION_END_TILE_ID = 9;

    /**
     * Pocet typu dlazdic pro zem
     * - pevna
     * - propadavajici     
     * - trampolina
     * - vetrak
     * - pojizdna plosina START
     * - pojizdna plosina END
     */
    private static readonly GROUND_TILE_TYPE_CNT = 6;

    /**
     * Bonusy
     */
    private static readonly BONUS_TILE_MIN_ID = 16;
    private static readonly BONUS_TILE_MAX_ID = 17;

    /**
     * Staticke prekazky
     */
    private static readonly STATIC_OBS_MIN_ID = 24;
    private static readonly STATIC_OBS_MAX_ID = 27;

    private static readonly STATIC_OBS_PILLAR = 24;
    private static readonly STATIC_OBS_TUNNEL = 26;

    /**
     * Pohybujici se prekazky
     */
    private static readonly MOVING_OBS_0_MIN_ID = 32;
    private static readonly MOVING_OBS_0_MAX_ID = 33;

    /**
     * Letajici prekazky
     */
    private static readonly FLYING_OBS_UP_MIN_ID = 40;
    private static readonly FLYING_OBS_UP_MAX_ID = 42;
    private static readonly FLYING_OBS_DOWN_MIN_ID = 43;
    private static readonly FLYING_OBS_DOWN_MAX_ID = 45;

    // Posunovaci prekazky
    private static readonly SHIFT_OBS_MIN_ID = 48;
    private static readonly SHIFT_OBS_MAX_ID = 55;

    // Kladivo
    private static readonly HAMMER_OBS_L_ID = 31;
    private static readonly HAMMER_OBS_R_ID = 28;

    // Rotujici kladivo
    private static readonly ROTATOR_OBS_MIN_ID = 56;
    private static readonly ROTATOR_OBS_MAX_ID = 63;

    // Laserove delo
    private static readonly CANNON_ID = 65;

    // Posun radku
    private static readonly ROW_SHIFT_R_MIN_ID = 80;
    private static readonly ROW_SHIFT_R_MAX_ID = 85;
    private static readonly ROW_SHIFT_L_MIN_ID = 86;
    private static readonly ROW_SHIFT_L_MAX_ID = 91;

    //#endregion

    //#region Nastaveni prekazek, atd.

    /**
     * Dicitionary pro ziskani ease funkce podle jejiho jmena
     */
    private static readonly _EASE_DIC: IDictionary<((k: number) => number)> = {
        "linear": pc.Linear,
        "cubicIn": pc.CubicIn,
        "cubicOut": pc.CubicOut,
        "bounceOut": pc.BounceOut,
        "elasticIn": pc.ElasticIn,
        "elasticOut": pc.ElasticOut,
        "backOut": pc.BackOut,
        "backIn": pc.BackIn,
    };

    /**
     * Dictionary pro ziskani funkce vytvarejici nastaveni (napr. prekazky) podle jejiho jmena
     */
    private static _SETTINGS_CREATE_DIC: IDictionary<({ fnc: (settingsKey: string, properties: IDictionary<TiledPropertyVal>) => void, key: string })>;

    /**
     * Nastaveni pro posun radek. 
     * Klic: LX a RX, kde X je index nastaveni L = posun vlevo, R = posun vpravo
     */
    private _rowShiftSettings: IDictionary<MapRowShiftSettings>;

    /**
     * Nastaveni pro posunujici se prekazky.
     * Klic: FUX/FDX (letajici nahoru, letajici dolu)
     */
    private _shiftingObsSettings: IDictionary<ShiftingObsSettings>;

    /**
     * Nastaveni pohyblivych prekazek pro jednotlive verze
     */
    private static _MOVING_OBS_SETTINGS: MovingObsSettings[] = [
        new MovingObsSettings(0, 0.4, 3, -270)
    ];

    /**
     * Nastaveni pro prekazku typu kladivo
     */
    private static _HAMMER_OBS_SETTINGS = new ObstacleSettings(eObstacleType.hammer, 0);

    /**
     * Nastaveni pro prekazku typu rotujici kladivo
     */
    private static _ROTATOR_OBS_SETTINGS = new ObstacleSettings(eObstacleType.rotator, 0);

    /**
     * Nastaveni pro delo
     */
    private static _CANNON_SETTINGS = new CannonObsSettings(0, 8);

    //#endregion

    /**
     * Seznam tagu sekci
     */
    //private _sectionTags: NodeList<SectionTag>;

    private _bonusGroupId: number;
    private _newBonusGroup: boolean;
    private _rowHasBonus: boolean;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        if (!Convertor._SETTINGS_CREATE_DIC) {
            Convertor._SETTINGS_CREATE_DIC = {
                "rowShiftL": { fnc: this.createRowShiftSets, key: "L" },
                "rowShiftR": { fnc: this.createRowShiftSets, key: "R" },
                "flyingObsU": { fnc: this.createShiftObsSets, key: "FU" },
                "flyingObsD": { fnc: this.createShiftObsSets, key: "FD" },
                "shiftingObs": { fnc: this.createShiftObsSets, key: "S" },
            }
        }

        //this._sectionTags = new NodeList<SectionTag>();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    convert(map: ITiledMap, output: MapSection[]): void {
        this.release();

        let cell = new Cell();
        let rowCells: number[] = [];

        for (let i = 0; i < MapRow.WIDTH; i++)
            rowCells.push(0);

        let groundTiles = (Convertor.getLayer(map.layers, Convertor.LAYER_GROUND_NAME) as ITiledTileLayer).data;
        let objectTiles = (Convertor.getLayer(map.layers, Convertor.LAYER_OBJECTS_NAME) as ITiledTileLayer).data;

        // Ziskat tagy sekci
        //this.parseSectionTags(map);

        // Ziskat nastaveni prekazek
        this.parseSettings(map);

        // Najit zacatek sekce mapy
        let sectionRow1 = 0;

        while ((sectionRow1 = this.findNextMapSection(groundTiles, sectionRow1)) >= 0) {
            let rowObstacles: ObstacleMapData[];
            let tileId = sectionRow1 * MapRow.WIDTH;
            let sectionRows: MapRow[] = [];

            // Skupiny bonusu
            this._bonusGroupId = 0;
            this._newBonusGroup = true;

            while (tileId < groundTiles.length && groundTiles[tileId] - 1 != Convertor.SECTION_END_TILE_ID) {
                let nonEmptyCellCnt = 0;
                let rowSettings: MapRowShiftSettings;

                this._rowHasBonus = false;

                for (let col = 0; col < MapRow.WIDTH; col++) {
                    this.createMapRowCell(col, groundTiles[tileId] - 1, objectTiles[tileId] - 1, cell);

                    if ((rowCells[col] = cell.cell) != 0) {
                        nonEmptyCellCnt++;

                        if (cell.obstacle) {
                            if (!rowObstacles)
                                rowObstacles = [];

                            rowObstacles.push(cell.obstacle);
                        }
                    }

                    if (cell.rowShift)
                        rowSettings = cell.rowShift;

                    tileId++;
                }

                if (nonEmptyCellCnt != 0) {
                    sectionRows.push(new MapRow(Array.from(rowCells), rowObstacles, rowSettings));
                    rowObstacles = undefined;
                }
                else {
                    sectionRows.push(undefined);
                }

                this._newBonusGroup = !this._rowHasBonus;
            }

            // Pridat sekci do seznamu
            output.push(new MapSection("", sectionRows));

            // Najit tag pro sekci
            let sectionRow2 = Math.floor(tileId / MapRow.WIDTH);

            /*this._sectionTags.every((tag: SectionTag, node: Node<SectionTag>): boolean => {
                if (tag.row >= sectionRow1 - 1 && tag.row <= sectionRow2) {
                    // Vytvorit novou sekci a pridat ji do seznamu sekci
                    output[tag.uid] = new MapSection(tag.uid, sectionRows);

                    // Odstranit tag
                    this._sectionTags.removeByNode(node);

                    return false;
                }

                return true;
            });*/

            // Postup do dalsi sekce
            sectionRow1 = sectionRow2 + 1;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    release(): void {
        //this._sectionTags.clear();
        this._shiftingObsSettings = {};
        this._rowShiftSettings = {};
    }

    //-------------------------------------------------------------------------
    /**
     * Najde zacatek dalsi sekce herni mapy.
     * @param map Pole s dlazdicemi pro zem
     * @param fromRow Index radky, od ktere se ma hledat nova sekce
     * @returns Vraci index radky, kde nova sekce zacina nebo -1, pokud sekci nenajde
     */
    //-------------------------------------------------------------------------
    private findNextMapSection(map: number[], fromRow: number): number {
        let mapPos = fromRow * MapRow.WIDTH;

        while (mapPos < map.length) {
            if (map[mapPos] - 1 == Convertor.SECTION_START_TILE_ID)
                return Math.floor(mapPos / MapRow.WIDTH) + 1;

            mapPos += MapRow.WIDTH;
        }

        return -1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private createMapRowCell(cellId: number, groundTile: number, objectTile: number, output: Cell): void {
        let cell = 0;

        output.obstacle = undefined;
        output.rowShift = undefined;

        if (groundTile >= 0) {
            // Typ dlazdice
            if (groundTile < Convertor.GROUND_TILE_TYPE_CNT) {
                cell = (groundTile + 1) << MapCell.TILE_TYPE_SHIFT;
            }
            else {
                cell = (1 << MapCell.TILE_TYPE_SHIFT) | ((groundTile - Convertor.GROUND_TILE_TYPE_CNT + 1) << MapCell.TILE_VERSION_SHIFT);
            }
        }

        if (objectTile >= 0) {
            // Bonusy
            if (objectTile >= Convertor.BONUS_TILE_MIN_ID && objectTile <= Convertor.BONUS_TILE_MAX_ID) {
                if (this._newBonusGroup)
                    this._bonusGroupId = (this._bonusGroupId + 1) & 1;

                cell |= ((objectTile - Convertor.BONUS_TILE_MIN_ID + 1) << MapCell.BONUS_TYPE_SHIFT);

                if (this._bonusGroupId != 0)
                    cell |= (1 << MapCell.BONUS_GROUP_SHIFT);

                this._rowHasBonus = true;
            }
            // Staticke prekazky
            else if (objectTile >= Convertor.STATIC_OBS_MIN_ID && objectTile <= Convertor.STATIC_OBS_MAX_ID) {
                let ver = -1;

                switch (objectTile) {
                    case Convertor.STATIC_OBS_PILLAR: {
                        ver = 0;
                        break;
                    }
                    case Convertor.STATIC_OBS_TUNNEL: {
                        ver = 1;
                        break;
                    }
                }

                if (ver >= 0)
                    output.obstacle = new ObstacleMapData(cellId, new ObstacleSettings(eObstacleType.static, ver));
            }
            // Prekazky pohybujici se ze strany na stranu
            else if (objectTile >= Convertor.MOVING_OBS_0_MIN_ID && objectTile <= Convertor.MOVING_OBS_0_MAX_ID) {
                output.obstacle = new MovingObsMapData(((cellId + 0.5) * TileBase.SIZE) / (MapRow.WIDTH * TileBase.SIZE), objectTile == Convertor.MOVING_OBS_0_MIN_ID ? 1 : -1, Convertor._MOVING_OBS_SETTINGS[0]);
            }
            // Letajici prekazky
            else if (objectTile >= Convertor.FLYING_OBS_UP_MIN_ID && objectTile <= Convertor.FLYING_OBS_DOWN_MAX_ID) {
                output.obstacle = new ObstacleMapData(cellId,
                    this._shiftingObsSettings[(objectTile <= Convertor.FLYING_OBS_UP_MAX_ID ? "FU" + (objectTile - Convertor.FLYING_OBS_UP_MIN_ID) : "FD" + (objectTile - Convertor.FLYING_OBS_DOWN_MIN_ID))]);
            }
            // Posunujici se prekazky
            else if (objectTile >= Convertor.SHIFT_OBS_MIN_ID && objectTile <= Convertor.SHIFT_OBS_MAX_ID) {
                output.obstacle = new ObstacleMapData(cellId, this._shiftingObsSettings["S" + (objectTile - Convertor.SHIFT_OBS_MIN_ID)]);
            }
            // Kladivo
            else if (objectTile == Convertor.HAMMER_OBS_L_ID || objectTile == Convertor.HAMMER_OBS_R_ID) {
                output.obstacle = new HammerObsMapData(cellId, objectTile == Convertor.HAMMER_OBS_L_ID ? -1 : 1, Convertor._HAMMER_OBS_SETTINGS);
            }
            // Rotujici kladivo
            else if (objectTile >= Convertor.ROTATOR_OBS_MIN_ID && objectTile <= Convertor.ROTATOR_OBS_MAX_ID + 1) {
                if (objectTile <= Convertor.ROTATOR_OBS_MAX_ID) {
                    objectTile -= Convertor.ROTATOR_OBS_MIN_ID;
                    output.obstacle = new RotatorObsMapData(cellId, (objectTile % 4) * 90, objectTile >= 4 ? 1 : -1, Convertor._ROTATOR_OBS_SETTINGS);
                }
            }
            // Laserove delo
            else if (objectTile == Convertor.CANNON_ID) {
                output.obstacle = new ObstacleMapData(cellId, Convertor._CANNON_SETTINGS);
            }
            // Posun radek
            else if (objectTile >= Convertor.ROW_SHIFT_R_MIN_ID && objectTile <= Convertor.ROW_SHIFT_L_MAX_ID) {
                output.rowShift = this._rowShiftSettings[(objectTile <= Convertor.ROW_SHIFT_R_MAX_ID ? "R" + (objectTile - Convertor.ROW_SHIFT_R_MIN_ID) : "L" + (objectTile - Convertor.ROW_SHIFT_L_MIN_ID))];
            }
        }

        output.cell = cell;
    }

    //-------------------------------------------------------------------------
    /**
     * Najde tagy pro jednotlive sekce mapy a vytvori jejich seznam
     * @param map 
     */
    //-------------------------------------------------------------------------
    /*private parseSectionTags(map: ITiledMap): void {
        let layers = (Convertor.getLayer(map.layers, Convertor.LAYER_SECTION_TAGS_NAME) as ITiledLayerGroup).layers;

        layers.forEach((layer: ITiledImageLayer) => {
            // Vytvorit tag a pridat ho do seznamu
            this._sectionTags.add(new SectionTag(layer.name.slice(4), Math.floor(layer.offsety / map.tileheight)));
        });
    }*/

    //-------------------------------------------------------------------------
    /**
     * Najde jednotliva nastaveni ve skupine "Settings" a vytvori jejich seznamy
     * @param map 
     */
    //-------------------------------------------------------------------------
    private parseSettings(map: ITiledMap): void {
        let layer = Convertor.getLayer(map.layers, Convertor.LAYER_SETTINGS_NAME) as ITiledLayerGroup;

        if (layer) {
            let layers = layer.layers;

            layers.forEach((layer: ITiledImageLayer) => {
                if (layer.visible) {
                    // Ziskat index nastaveni
                    let name = layer.name;
                    let i = name.lastIndexOf("_");
                    let settingsId = parseInt(name.slice(i + 1));

                    // Podle jmena nastaveni zavolat funkci pro vytvoreni nastaveni
                    let entry = Convertor._SETTINGS_CREATE_DIC[name.slice(0, i)];

                    entry.fnc.call(this, entry.key + settingsId, Convertor.getProperties(layer.properties));
                }
            });
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Vytvorit nastaveni pro posun radky
     * @param settingsName
     * @param settingsId 
     * @param props 
     */
    //-------------------------------------------------------------------------
    private createRowShiftSets(settingsKey: string, props: IDictionary<TiledPropertyVal>): void {
        this._rowShiftSettings[settingsKey] = new MapRowShiftSettings(
            props["offset"] as number,
            0,
            props["shiftS"] as number,
            props["shiftE"] as number,
            Convertor._EASE_DIC[Convertor.getProperty(props, "shiftEase", "linear") as string]);
    }

    //-------------------------------------------------------------------------
    /**
     * Vytvoreni nastaveni pro shiftingObstalces
     * @param settingsKey 
     * @param props 
     */
    //-------------------------------------------------------------------------
    private createShiftObsSets(settingsKey: string, props: IDictionary<TiledPropertyVal>): void {
        this._shiftingObsSettings[settingsKey] = new ShiftingObsSettings(
            Convertor.getProperty(props, "version", 0) as number,
            Convertor.getProperty(props, "deadly", true) as boolean,
            new pc.Vec3(Convertor.getProperty(props, "posOffsetX", 0) as number, Convertor.getProperty(props, "posOffsetY", 0) as number, Convertor.getProperty(props, "posOffsetZ", 0) as number),
            Convertor.getProperty(props, "visible", true) as boolean,
            props["shiftS"] as number,
            props["shiftE"] as number,
            new pc.Vec3(Convertor.getProperty(props, "shiftDisX", 0) as number, Convertor.getProperty(props, "shiftDisY", 0) as number, Convertor.getProperty(props, "shiftDisZ", 0) as number),
            Convertor._EASE_DIC[Convertor.getProperty(props, "shiftEase", "linear") as string]
        );
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci vrstvu s danym jmenem nebo undefined
     * @param layers
     * @param layerName 
     */
    //-------------------------------------------------------------------------
    private static getLayer(layers: ITiledLayer[], layerName: string): ITiledLayer {
        let i = layers.length;

        while (i-- != 0) {
            if (layers[i].name == layerName)
                return layers[i];
        }

        return undefined;
    }

    //-------------------------------------------------------------------------
    /**
     * Prevede pole IProperty[] na IDictionary, kde se indexuje pres IProperty.name a value je hodnota property.
     * @param props 
     */
    //-------------------------------------------------------------------------
    private static getProperties(props: ITiledProperty[]): IDictionary<TiledPropertyVal> {
        let dic: IDictionary<TiledPropertyVal> = {};

        props.forEach((p: ITiledProperty) => { dic[p.name] = p.value; });

        return dic;
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci hodnotu property pokud existuje. Pokud neexistuje, tak vrati zadanou vychozi hodnotu
     * @param props 
     * @param name 
     * @param defValue 
     */
    //-------------------------------------------------------------------------
    private static getProperty(props: IDictionary<TiledPropertyVal>, name: string, defValue: TiledPropertyVal): TiledPropertyVal {
        let prop = props[name];

        if (prop == undefined)
            return defValue;

        return prop;
    }








    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    /*    static createMap(): MapSectionGroup[] {
            // Ziskat export z Tiled nacteny jako JSON objekt
            let map = Game.APP.assets.find(Game.LEVEL_ASSET_KEY, pc.eAssetType.json).resource as ITiledMap;
    
            // Vytvorit nastaveni podle polozek ve vrstve "Settings"
            Convertor.parseSettings((Convertor.getLayer(map.layers, "Settings") as ITiledLayerGroup).layers as ITiledImageLayer[]);
    
            // Vytvorit jednotlive radky mapy
            let groundData = (Convertor.getLayer(map.layers, Convertor.LAYER_GROUND_NAME) as ITiledTileLayer).data;
            let objectsData = (Convertor.getLayer(map.layers, Convertor.LAYER_OBJECTS_NAME) as ITiledTileLayer).data;
            let dataPos = (map.height - 1) * MapRow.WIDTH;
    
            let mapRows: MapRow[] = [];
            let rowObstacles: ObstacleMapData[];
            let cell = new Cell();
            let cells: number[] = [];
    
            for (let i = 0; i < MapRow.WIDTH; i++)
                cells.push(0);
    
            for (let row = map.height - 1; row >= 0; row--) {
                let nonEmptyCellCnt = 0;
                let rowSettings: MapRowShiftSettings;
    
                for (let col = 0; col < MapRow.WIDTH; col++) {
                    Convertor.createMapRowCell(col, groundData[dataPos] - 1, objectsData[dataPos] - 1, cell);
    
                    if ((cells[col] = cell.cell) != 0) {
                        nonEmptyCellCnt++;
    
                        if (cell.obstacle) {
                            if (!rowObstacles)
                                rowObstacles = [];
    
                            rowObstacles.push(cell.obstacle);
                        }
                    }
    
                    if (cell.rowShift)
                        rowSettings = cell.rowShift;
    
                    dataPos++;
                }
    
                if (nonEmptyCellCnt != 0) {
                    mapRows.push(new MapRow(Array.from(cells), rowObstacles, rowSettings));
                    rowObstacles = undefined;
                }
                else {
                    mapRows.push(undefined);
                }
    
                dataPos -= MapRow.WIDTH * 2;
            }
    
            return [
                new MapSectionGroup(1, [
                    new MapSection(1, mapRows)
                ])
            ];
        }*/
}